import { ChangeEvent, FC, useMemo } from 'react'

import { FormSelect } from '@/components'
import { trans } from '@/helpers/trans'
import { ColleagueViewModel, UserViewModel } from '@/models'

import { getUserSelectOptions } from './helpers/getUserSelectOptions'


interface FormUserSelectProps {
    users: (UserViewModel | ColleagueViewModel)[]
    selectedUser: string | null
    onSelectUser: (userId: string) => void
}

export const FormUserSelect: FC<FormUserSelectProps> = ({
    selectedUser,
    users,
    ...props
}) => {
    const options = useMemo(() => getUserSelectOptions(users), [users])

    const onSelectUser = (event: ChangeEvent<HTMLSelectElement>) => {
        const value = users.find(user => user.id === event.target.value)

        if (value) {
            props.onSelectUser(value.id)
        }
    }

    return (
        <FormSelect
            options={options}
            selected={selectedUser}
            title={trans('pages.exchanges.chooseAnEmployee')}
            onChange={onSelectUser}
        />
    )
}
